import React, { Component } from 'react'
import { Table,message } from 'antd'
import SideNav from "../SideNav";
import Filter from './Filter'
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import $ from '../../../common/AjaxRequest';
import TableC from "../../basicElement/TableC";
import format from '../../shared/format';
import ExportUtil from '../../../common/ExportUtil';


export default class Incomestatement extends Component {
    state = {
        searchParams:{
            quarterNum:[],
            accountLedger:[]
        },
        data:[],
        Currencylist:[],
        pagination:{
            current:1,
            pageSize:10
        },
        sortParams:{},
        stageList: [],
        businessList: [],
    }

    componentDidMount() {
        this.getTime();
        this.loadAllCurrencyExchangeRateList();
        this.loadTypeConfigureList();
        this.queryBusiness();
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    getTime = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate,{
            }).then(cb).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
        }, res => {
            const { year,month,date } = res;
            const {searchParams} = this.state
            searchParams.yearNum = year;
            searchParams.year = year;
            searchParams.monthNum = month;
            searchParams.quarterNum = [`Q${moment(date).quarter()}`]
            this.setState({
                searchParams
                },()=>this.loadData());
        });
    }

    loadAllCurrencyExchangeRateList = () => {
        //币种查询功能，获取后端数据来作为币种查询的选项
        dictCache.getDict('CURRENCY_RATE_ALL', cb => {
            Fetch.post(API_URL.contract.queryAllCurrencyExchangeRate,{

            }).then(cb).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
        }, res => {
            const { data = [] } = res;   //接收的data如果是undefind，则赋值为空的数组
            this.setState({
                Currencylist: data,
                    });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                stageList: res.stageList,
            });
        });
    }

     //获取业务线选项
    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { searchParams, pagination} = this.state;
        const { current, pageSize } = pagination;
        this.setState({ 
            loading: true
        });

        Fetch.post(API_URL.dashboard.queryIncomeReportFormsList, {
            offset: current,
            limit: pageSize,
            ...searchParams,
            quarterNum:searchParams.quarterNum.join(','),    //季度下拉多选框传来的数据合成成字符串传值给后台，arr.join()合并数组
            accountLedger:searchParams.accountLedger.join(','),

        
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    export = () => {
        const {searchParams} = this.state
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportIncomeReportFormsList,
            data: {
                ...searchParams,
                quarterNum:searchParams.quarterNum.join(','),    
                accountLedger:searchParams.accountLedger.join(','),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                
            },
        };
        $.sendRequest(options);
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams }});
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination:pagination.pagination
        },() => {
            this.loadData();
        })
        
    }

    getColumns = () =>[        
        {
            title: '年份',
            dataIndex: 'yearNum',
            key: 'yearNum',
            width:80
        }, {
            title: '季度',
            dataIndex: 'quarterNum',
            key: 'quarterNum',
            width:80
        },{
            title: '月份',
            dataIndex: 'monthNum',
            key: 'monthNum',
            width:80
        },{
            title: '公司代码',
            dataIndex: 'company',
            key: 'company',
            width:100
        },{
            title: '公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
            width:160
        },{
            title: '项目识别码',
            dataIndex: 'identifyCode',
            key: 'identifyCode',
            width:160
        },{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width:160
        },{
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width:160
        },{
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width:160
        },{
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width:120
        },{
            title: 'JDE项目号',
            dataIndex: 'projectCode',
            key: 'projectCode',
            width:120
        },{
            title: '科目账-明细账',
            dataIndex: 'accountLedger',
            key: 'accountLedger',
            width:120
        },{
            title: '收入种类',
            dataIndex: 'incomeType',
            key: 'incomeType',
            width:160
        },{
            title: '项目代码',
            dataIndex: 'projectName',
            key: 'projectName',
            width:100
        },{
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width:80
        },{
            title: 'BU',
            dataIndex: 'bu',
            key: 'bu',
            width:150
        },{
            title: 'Line',
            dataIndex: 'line',
            key: 'line',
            width:80
        },{
            title: 'SubLine',
            dataIndex: 'subLine',
            key: 'subLine',
            width:80
        },{
            title: 'Director',
            dataIndex: 'director',
            key: 'director',
            width:80
        },{
            title: 'FFSFTE',
            dataIndex: 'ffsFte',
            key: 'ffsFte',
            width:80
        },{
            title: '国家',
            dataIndex: 'country',
            key: 'country',
            width:80
        },{
            title: 'CostCenter',
            dataIndex: 'costCenter',
            key: 'costCenter',
            width:100
        },{
            title: '区域',
            dataIndex: 'geography',
            key: 'geography',
            width:80
        },{
            title: '批号-单据号',
            dataIndex: 'entryNo',
            key: 'entryNo',
            width:120
        },{
            title: '客户JDE号',
            dataIndex: 'customerCode',
            key: 'customerCode',
            width:120
        },{
            title: '客户名称',
            dataIndex: 'customerName',
            key: 'customerName',
            width:120
        },{
            title: '记账人',
            dataIndex: 'cs',
            key: 'cs',
            width:120
        },{
            title: 'ActSiteCode',
            dataIndex: 'actSiteCode',
            key: 'actSiteCode',
            width:120
        },{
            title: 'ActSite',
            dataIndex: 'actSite',
            key: 'actSite',
            width:120
        },{
            title: '分类账',
            dataIndex: 'ledger',
            key: 'ledger',
            width:120
        },{
            title: '收入类型',
            dataIndex: 'revType',
            key: 'revType',
            width:120
        },{
            title: '部门代码',
            dataIndex: 'buCode',
            key: 'buCode',
            width:120
        },{
            title: '原币金额',
            dataIndex: 'originalCurrencyAmount',
            key: 'originalCurrencyAmount',
            width:120,
            render: text => format('money', text), 
        },{
            title: '本币金额',
            dataIndex: 'domesticCurrencyAmount',
            key: 'domesticCurrencyAmount',
            width:120,
            render: text => format('money', text), 
        },{
            title: '美金金额',
            dataIndex: 'usd',
            key: 'usd',
            width:120,
            render: text => format('money', text), 
        },{
            title: '人民币金额',
            dataIndex: 'rmb',
            key: 'rmb',
            width:120,
            render: text => format('money', text), 
        },{
            title: '累计收入不含税/原币',
            dataIndex: 'cumulativeIncomeNoTaxInitial',
            key: 'cumulativeIncomeNoTaxInitial',
            width:120,
            render: text => format('money', text), 
        },{
            title: '累计收入不含税/人民币',
            dataIndex: 'cumulativeIncomeNoTaxCny',
            key: 'cumulativeIncomeNoTaxCny',
            width:120,
            render: text => format('money', text), 
        },{
            title: 'Site',
            dataIndex: 'site',
            key: 'site',
            width:120
        },{
            title: '总账日期',
            dataIndex: 'generalLedgerDate',
            key: 'generalLedgerDate',
            width:120
        },{
            title: '自定义发票号',
            dataIndex: 'customInvoiceNumber',
            key: 'customInvoiceNumber',
            width:120
        },{
            title: 'GLTORG',
            dataIndex: 'gltorg',
            key: 'gltorg',
            width:120
        },{
            title: 'ManagerialAnalysisCode3',
            dataIndex: 'managerialAnalysisCode3',
            key: 'managerialAnalysisCode3',
            width:100
        },{
            title: 'Actuate_AMT',
            dataIndex: 'actuateAmt',
            key: 'actuateAmt',
            width:170
        }
    ]
    // 下载模板
    downloadTemplate() {
        const url = API_URL.dashboard.exportIncomeReportFormsTemplate;
        ExportUtil.export(null, null, url);
    }

    render() {
        const {data,searchParams,pagination,Currencylist,sortParams,stageList,businessList} = this.state;
        return (
        <div className="content">
                    <SideNav selectKey="incomestatement" />
                    <div className="main">
                        <Filter 
                            search={this.search}
                            export={this.export}
                            onChange={this.handleChange}    
                            searchParams={searchParams}
                            Currencylist={Currencylist}
                            stageList={stageList}
                            businessList={businessList}
                            downloadTemplate={this.downloadTemplate}
                        />
                    
                        <TableC
                            scrollY={500}
                            columns={this.getColumns()}
                            sortParams={sortParams}
                            data={data}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/financeManagement/incomestatement/index.js